import { TDateObject } from '@/types';

/**
 * Get date object from javascript date object
 * @param date javascript date object
 * @returns
 */
const getDateObject = (date: Date): TDateObject => {
  if (!date) {
    return { year: null, month: null, day: null };
  }
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Adding 1 because getMonth() returns zero-based month
  const day = date.getDate();

  return { year, month, day };
};

export default getDateObject;
